export class PushNotificationRequestModel {
  public deviceID?: string;
  public deviceFCMToken?: string;
}
